/** Geldbeträge im deutschen Format mit €-Symbol. */
export function formatEuro(value: number | null | undefined, decimals = 2): string {
  if (value == null || !Number.isFinite(Number(value))) return "—";
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(Number(value));
}
